export const sustainabilityHubPage = {
    heading:'sustainability-hub-page-heading',
    text:'sustainability-hub-page-text',
    sectionTitle:'sustainability-hub-tile-link',
}